<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary">Asset</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Asset</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="asset.id === null">New</span>
                <span v-else>
                  {{ asset.asset_no }}
                </span>
              </li>
            </ol>
            <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
            <div class="dropdown-menu" aria-labelledby="printsales">
              <a class="dropdown-item" href="javascript:void(0)" @click="validate">Validate</a>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalProcessAsset" data-backdrop="static" data-keyboard="false">Process Akumulasi by date</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="reprocess">Re-process Akumulasi</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="setJournalBuy">Journal Asset Buy</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="setJournalSell">Journal Asset Sell</a>
            </div>
            <button type="button" @click="update" class="btn btn-sm btn-soft-primary pull-left" v-show="asset.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
            <button type="button" @click="save" class="btn btn-sm btn-soft-primary pull-left" v-show="asset.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
          </div>
          </div>
        </div>
      </div>
      <div class="card card-list">
          <div class="card-header">
            <h4>
              <span v-if="asset.asset_no !== null"><b>{{ asset.asset_no }}</b> - {{ asset.asset_name }}</span>
              <span v-else>New</span>
            </h4>
          </div>
          <div class="card-body">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
              <ul v-for="(a, index) in alert" :key="index">
                <li v-html="a"></li>
              </ul>
            </div>
            <ul class="nav nav-tabs nav-bordered">
              <li class="nav-item"><a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">General</a></li>
              <li class="nav-item"><a href="#price" data-toggle="tab" aria-expanded="false" class="nav-link">Data Transaksi</a></li>
              <li class="nav-item"><a href="#data" data-toggle="tab" aria-expanded="false" class="nav-link">Log Akumulasi</a></li>
              <li class="nav-item"><a href="#maintenance" data-toggle="tab" aria-expanded="true" class="nav-link">Maintenance</a></li>
              <li class="nav-item"><a href="#sell" data-toggle="tab" aria-expanded="true" class="nav-link">Sell</a></li>
              <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="true" class="nav-link">Journal</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="general">
                <div class="row">
                  <div class="col-md-4">
                    <div id="product-img-border"  @click="chooseFiles">
                      <img :src="`${publicPath}asset/img/product.png`" id="product-img" class="ml-auto" v-if="asset.picture === null">
                      <img :src="asset.picture" id="product-img" class="ml-auto" v-else/>
                      <input type="file" id="file" ref="file" @change="handleFileUpload()" hidden/>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <dl class="dl-custom row font-12">
                      <dt class="col-md-4">&nbsp;</dt>
                      <dd class="col-md-8">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="active" v-model="asset.active">
                          <label class="form-check-label" for="active"><b>Active</b></label>
                        </div>
                      </dd>
                      <dt class="col-md-4">Company</dt>
                      <dd class="col-md-8">
                        <select v-model="asset.company_no" class="form-control">
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Type <span style="color: red">*</span></dt>
                      <dd class="col-md-8">
                        <select v-model="asset.type_id" class="form-control">
                          <option v-for="a in assetTypeList" :key="a.id" :value="a.id">{{ a.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Name <span style="color: red">*</span></dt>
                      <dd class="col-md-8">
                        <input v-model="asset.asset_name" class="form-control"/>
                      </dd>
                      <dt class="col-md-4">Condition</dt>
                      <dd class="col-md-8">
                        <select v-model="asset.condition" class="form-control">
                          <option value="ready">Ready</option>
                          <option value="maintenance">Maintenance</option>
                          <option value="sell">Sell</option>
                        </select>
                      </dd>
                    </dl>
                  </div>
                  <div class="col-md-4">
                    <dl class="dl-custom row">
                      <dt class="col-md-4">Serial Number</dt>
                      <dd class="col-md-8">
                        <input v-model="asset.serial_number" class="form-control"/>
                      </dd>
                      <dt class="col-md-4">Internal Number</dt>
                      <dd class="col-md-8">
                        <input v-model="asset.internal_number" class="form-control"/>
                      </dd>
                      <dt class="col-md-4">Description</dt>
                      <dd class="col-md-8">
                        <textarea class="form-control" v-model="asset.description"  cols="5"></textarea>
                      </dd>

                      <dt class="col-md-4">Fuel Bar</dt>
                      <dd class="col-md-4">
                          <input type="text" v-model="asset.fuel_qty_bigger" class="form-control" />
                      </dd>
                      <dd class="col-md-4">
                        <select v-model="asset.fuel_uom_bigger" class="form-control">
                          <option v-for="i in uomList" :key="i.id" :value="i.id">{{ i.name}}</option>
                        </select>
                      </dd>

                      <dt class="col-md-4">Fuel Liter</dt>
                      <dd class="col-md-4">
                          <input type="text" v-model="asset.fuel_qty_reference" class="form-control" />
                      </dd>
                      <dd class="col-md-4">
                        <select v-model="asset.fuel_uom_reference" class="form-control">
                          <option v-for="i in uomList" :key="i.id" :value="i.id">{{ i.name}}</option>
                        </select>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="price">
                <div class="row">
                  <div class="col-md-4">
                    <h4 class="mt-0 header-title">Transaksi</h4>
                    <hr>
                    <dl class="dl-custom row">
                      <dt class="col-md-4">Tgl. Transaksi</dt>
                      <dd class="col-md-8"><datetime v-model="asset.date_buy" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime></dd>

                      <dt class="col-md-4">Nilai Asset</dt>
                      <dd class="col-md-8"><input type="text" class="form-control form-right" v-model.lazy="asset.asset_amount" v-money="money"/></dd>

                      <dt class="col-md-4">Account Payment</dt>
                      <dd class="col-md-8">
                        <select v-model="asset.account_code" class="form-control">
                          <option v-for="a in accountSelect" :key="a.id" :value="a.account_code">{{ a.account_code }} - {{ a.account_name }}</option>
                        </select>
                      </dd>

                      <dt class="col-md-4">Memo No.</dt>
                      <dd class="col-md-8"><input v-model="asset.memo_no" class="form-control"/></dd>
                    </dl>
                  </div>
                  <div class="col-md-4">
                    <h4 class="mt-0 header-title">Akumulasi</h4>
                    <hr>
                    <dl class="dl-custom row">
                      <dt class="col-md-4">Tgl Mulai Akumulasi</dt>
                      <dd class="col-md-8"><datetime v-model="asset.date_reduce" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime></dd>

                      <dt class="col-md-4">Umur Ekonomis (Bulan)</dt>
                      <dd class="col-md-8"><input v-model="asset.asset_age" class="form-control"/></dd>

                      <dt class="col-md-4">Nilai Penyusutan</dt>
                      <dd class="col-md-8"><input type="text" class="form-control form-right" v-model.lazy="asset.asset_amount_reduce" v-money="money"/></dd>
                    </dl>
                    <hr />
                    <dl class="dl-custom row">
                      <dt class="col-md-4">Tgl. Process Terakhir</dt>
                      <dd class="col-md-8"><datetime v-model="asset.date_process" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" disabled="disabled"></datetime></dd>

                      <dt class="col-md-4">Sisa</dt>
                      <dd class="col-md-8"><input type="text" class="form-control form-right" v-model.lazy="asset.asset_fix_amount" v-money="money" id='asset_fix_amount' disabled="disabled"/></dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="data">
                  <div class="table-responsive">
                      <table class="table table-item mb-0 table-sm table-hover">
                          <thead>
                              <th>Process Date</th>
                              <th>Nilai Penyusutan</th>
                              <th>Penyusutan Ke-</th>
                              <th>Log Date</th>
                              <th>Created By</th>
                              <th>#</th>
                          </thead>
                          <tbody>
                              <tr v-for="l in asset.logs" :key="l.id">
                                <td>{{ l.process_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td>{{ l.amount | currency }}</td>
                                <td>{{ l.log_age }}</td>
                                <td>{{ l.log_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td>{{ l.username }}</td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-primary" @click="setJournalAkumulasi(l.id)">
                                    Set Journal
                                  </button>
                                </td>
                              </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <td>{{ totalPenyusutan | currency }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tfoot>
                      </table>
                  </div>
              </div>
              <div class="tab-pane" id="sell">
                <div class="col-md-4">
                  <div class="form-group row">
                    <label for="type_id" class="col-sm-3 col-form-label text-left">Sell Date</label>
                    <div class="col-sm-9">
                      <datetime v-model="asset.sell_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="type_id" class="col-sm-3 col-form-label text-left">Sell Amount</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control form-right" v-model.lazy="asset.sell_amount" v-money="money" id='sell_amount'/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="account_code"  class="col-sm-3 col-form-label text-left">Account</label>
                    <div class="col-sm-9">
                      <select v-model="asset.account_sell_code" class="form-control">
                        <option value="">---</option>
                        <option v-for="a in accountSelect" :key="a.id" :value="a.account_code">{{ a.account_code }} - {{ a.account_name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="maintenance">
                <div class="table-responsive">
                  <table class="table table-item mb-0 table-sm table-hover">
                    <thead>
                          <th style="width: 20%">Supplier No.</th>
                          <th>Memo No.</th>
                          <th>Date</th>
                          <th>Subtotal</th>
                          <th>Discount</th>
                          <th>Type Tax</th>
                          <th>Tax</th>
                          <th>Total</th>
                          <th>Description</th>
                          <th>#</th>
                        </thead>
                        <tbody>
                            <tr v-for="(l, index) in getFaMaintenance" :key="l.id">
                              <td><v-select :options="getSupplierList" :reduce="supplier => supplier.meta.code" label="supplier" v-model="l.supplier_no"/></td>
                              <td><input type="text" v-model="l.memo_no" class="form-control"></td>
                              <td><input type="text" v-mask="'##/##/####'" v-model="l.maintenance_date" class="form-control"  placeholder="dd/mm/yyyy"/></td>
                              <td><input type="text" class="form-control" v-model.lazy="l.subtotal" v-money="money" v-on:keyup="calcRowTotal(index)" /></td>
                              <td><input type="text" class="form-control" v-model.lazy="l.discount" v-money="money" v-on:keyup="calcRowTotal(index)"/></td>
                              <td>
                                <select v-model="l.tax_type" class="form-control" @change="calcRowTotal(index)">
                                  <option value="in">Include</option>
                                  <option value="ex">Exclude</option>
                                </select>
                              </td>
                              <td>
                                <input type="text" class="form-control" v-model.lazy="l.tax" v-money="money" v-on:keyup="calcRowTotal(index)"/>
                              </td>
                              <td><input type="text" class="form-control" v-model.lazy="l.total" v-money="money"/></td>
                              <td><input type="text" class="form-control" v-model="l.description"/></td>
                              <td><button type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button></td>
                            </tr>
                            <tr>
                              <td><span style="color: blue; cursor:pointer" @click="addMaintenance">add Line</span></td>
                            </tr>
                        </tbody>
                  </table>
                </div>
              </div>
              <div class="tab-pane" id="journal">
                <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                          <th>Date</th>
                          <th>Journal Code</th>
                          <th>Description</th>
                          <th>Account Code</th>
                          <th>Remark</th>
                          <th>Debit</th>
                          <th>Credit</th>
                        </thead>
                        <tbody>
                            <tr v-for="l in asset.journal" :key="l.id">
                              <td>{{ l.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ l.journal_code }}</td>
                              <td><b>{{ l.journal_description }}</b></td>
                              <td>{{ l.account_code }} - {{ l.account }}</td>
                              <td>{{ l.remark }}</td>
                              <td>{{ l.debit | currency }}</td>
                              <td>{{ l.credit | currency }}</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
          </div>
      </div>
      <AssetModal @processDate="processDate"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
// import FixedAssetModal from '@/components/finance/FixedAssetModal.vue'
import { assetUrl, getHeader } from '@/config'
import Axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import AssetModal from '@/components/finance/AssetModal.vue'

export default {
  name: 'AssetForm',
  props: ['asset'],
  components: {
    Loading,
    AssetModal
  },
  data () {
    return {
      alert: [],
      publicPath: process.env.BASE_URL,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      assetTypeList: state => state.assets.assetTypeList,
      accountList: state => state.accounts.accountList,
      branchList: state => state.branches.branchList,
      // employeeList: state => state.employees.employees,
      vendorList: state => state.vendors.vendorList,
      companyList: state => state.companies.companyList,
      uomList: state => state.uom.uomList
    }),
    getAssetTypeList () {
      var array = this.assetTypeList.filter(d => d.company_no === this.asset.company_no)
      return array
    },
    dataCollect () {
      var assetAmount = this.asset.asset_amount.replace(/\./g, '')
      assetAmount = assetAmount.replace(',', '.')
      var assetAmountReduce = this.asset.asset_amount_reduce.replace(/\./g, '')
      assetAmountReduce = assetAmountReduce.replace(',', '.')
      var assetFixAmount = this.asset.asset_fix_amount.replace(/\./g, '')
      assetFixAmount = assetFixAmount.replace(',', '.')
      var sellAmount = this.asset.sell_amount.replace(/\./g, '')
      sellAmount = sellAmount.replace(',', '.')
      const status = this.asset.account_sell_code !== null ? 'sold' : this.asset.status
      var obj = {
        id: this.asset.id,
        asset_no: this.asset.asset_no,
        type_id: this.asset.type_id,
        asset_name: this.asset.asset_name,
        date_buy: this.asset.date_buy,
        date_reduce: this.asset.date_reduce,
        date_process: this.asset.date_process,
        asset_age: this.asset.asset_age,
        asset_age_remaining: this.asset.asset_age_remaining,
        asset_amount: assetAmount,
        asset_amount_reduce: assetAmountReduce,
        asset_fix_amount: assetFixAmount,
        outlet_code: this.asset.outlet_code,
        account_code: this.asset.account_code,
        serial_number: this.asset.serial_number,
        internal_number: this.asset.internal_number,
        description: this.asset.description,
        memo_no: this.asset.memo_no,
        status: status,
        sell_date: this.asset.sell_date,
        sell_amount: sellAmount,
        account_sell_code: this.asset.account_sell_code,
        company_no: this.asset.company_no,
        condition: this.asset.condition,
        active: this.asset.active,
        fuel_qty_reference: this.asset.fuel_qty_reference,
        fuel_uom_reference: this.asset.fuel_uom_reference,
        fuel_qty_bigger: this.asset.fuel_qty_bigger,
        fuel_uom_bigger: this.asset.fuel_uom_bigger
      }
      return obj
    },
    getFaUser: function () {
      if (this.asset.fauser) {
        return this.asset.fauser.filter(d => d.id !== null)
      } else {
        var fauser = [{
          id: null,
          asset_no: null,
          employee_no: null,
          start_date: null,
          end_date: null,
          notes: null
        }]
        return fauser
      }
    },
    getFaMaintenance: function () {
      if (this.asset.famaintenance) {
        return this.asset.famaintenance.filter(d => d.id !== null)
      } else {
        var famaintenance = [{
          id: null,
          asset_no: null,
          memo_no: null,
          maintenance_date: null,
          description: null,
          subtotal: null,
          discount: null,
          tax_type: null,
          tax: null,
          total: null,
          supplier_no: null
        }]
        return famaintenance
      }
    },
    getEmployeeList: function () {
      // var array = this.employeeList
      var loop = []
      // for (let i = 0; i < array.length; i++) {
      //   var obj = {
      //     employee: array[i].employee_no + ' - ' + array[i].name,
      //     meta: {
      //       code: array[i].employee_no
      //     }
      //   }
      //   loop.push(obj)
      // }
      return loop
    },
    getSupplierList: function () {
      var array = this.vendorList
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          supplier: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    outletSelectList: function () {
      return this.outletList
    },
    totalPenyusutan: function () {
      var sum = 0
      var array = this.asset.logs
      if (array) {
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    accountSelect: function () {
      return this.accountList
    }
  },
  methods: {
    async setJournalSell () {
      console.log('set journal buy')
      this.$emit('editAsset', this.asset.id)
      this.$Progress.start()
      this.loader.isLoading = true
      await Axios.put(assetUrl + '/' + this.asset.id, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data, 'error')
          throw error
        })
      await Axios.post(assetUrl + '/journal-asset-sell', { id: this.asset.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log('editAsset ' + this.asset.id)
          this.$emit('editAsset', this.asset.id)
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data, 'error')
          throw error
        })
    },
    async setJournalBuy () {
      console.log('set journal buy')
      this.$emit('editAsset', this.asset.id)
      this.$Progress.start()
      this.loader.isLoading = true
      await Axios.put(assetUrl + '/' + this.asset.id, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data, 'error')
          throw error
        })
      await Axios.post(assetUrl + '/journal-asset-buy', { id: this.asset.id }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log('editAsset ' + this.asset.id)
          this.$emit('editAsset', this.asset.id)
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data, 'error')
          throw error
        })
    },
    async processDate (value) {
      await this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        id: this.asset.id,
        date_process: value === null ? new Date().toISOString() : value
      }
      await Axios.post(assetUrl + '/process', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.$emit('editAsset', this.asset.id)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    chooseFiles: function () {
      document.getElementById('file').click()
    },
    async handleFileUpload () {
      await this.$Progress.start()
      this.loader.isLoading = true
      this.file = this.$refs.file.files[0]
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('asset_no', this.asset.asset_no)
      const newHeader = {
        'Content-Type': 'multipart/form-data'
      }
      const newObj = Object.assign(getHeader(), newHeader)
      var url = assetUrl + '/pictures'
      console.log(url)
      console.log(formData)
      await Axios.post(url, formData, { headers: newObj })
        .then(response => {
          console.log(response.data.data)
          this.asset.picture = response.data.data.url
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.fail()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async validate () {
      this.alert = []
      if (this.asset.asset_name === null) {
        this.alert.push('<b>Name</b> harus diinput terlebih dahulu')
      }
      if (this.asset.type_id === null) {
        this.alert.push('<b>Type</b> harus diinput terlebih dahulu')
      }
    },
    calcRowTotal: function (index) {
      var no = 0
      if (this.asset.famaintenance[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var amount = parseFloat(this.asset.famaintenance[no].subtotal.toString().replace(/\./g, ''))
      var discount = parseFloat(this.asset.famaintenance[no].discount.toString().replace(/\./g, ''))
      var tax = (amount - discount) * 10 / 100
      var total = 0
      if (this.asset.famaintenance[no].tax_type === 'ex') {
        total = amount - discount + tax
        this.asset.famaintenance[no].tax = tax
      } else {
        total = amount - discount
        this.asset.famaintenance[no].tax = '0'
      }
      this.asset.famaintenance[no].total = total
    },
    addMaintenance: function () {
      var obj = {
        asset_no: null,
        memo_no: null,
        maintenance_date: null,
        description: null,
        subtotal: null,
        discount: null,
        tax_type: 'ex',
        tax: null,
        total: null,
        supplier_no: null
      }
      this.asset.famaintenance.push(obj)
    },
    addUser: function () {
      var obj = {
        asset_no: null,
        employee_no: null,
        start_date: null,
        end_date: null,
        notes: null
      }
      this.asset.fauser.push(obj)
    },
    async reprocess () {
      this.$swal.fire({
        title: 'Are you sure Process this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, process it!'
      }).then((result) => {
        if (result.value) {
          Axios.put(assetUrl + '/' + this.asset.id, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data, 'error')
              throw error
            })
          Axios.get(assetUrl + '/reprocess/' + this.asset.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.data)
              this.$emit('backReload', this.asset.id)
              this.$swal('Success', response.data.message, 'success')
              this.$emit('editAsset', this.asset.id)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    setJournalAkumulasi: function (id) {
      Axios.get(assetUrl + '/journal-akumulasi/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    saveProcess: function (value) {
      this.asset.date_process = value
      Axios.put(assetUrl + '/' + this.asset.id, this.asset, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async save () {
      this.validate()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data Asset tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await Axios.post(assetUrl, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$emit('backClicked')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async update () {
      this.validate()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data Asset tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await Axios.put(assetUrl + '/' + this.asset.id, this.dataCollect, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$emit('backClicked')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  }
}
</script>
